import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "react-materialize";
import FormFunc from "../../../utils/FormFunc";
import Func from "../../../utils/Func";
import { useInfo } from "context/InfoContext";
import config from "../../../config";
import API from "../../../utils/API";


const GetSelectOptions = (name, data, filterData) => {
  if (data.index === -1) {
    return [];
  }
  const recipData = filterData.email_recips[data.index];
  const relate_country = recipData.relate_country;
  const relate_field = recipData.relate_field;
  const relate_senttype = recipData.relate_senttype;
  if (name === "select-senttype" && relate_field.indexOf(name) >= 0) {
    return filterData.senttypes;
  } else if (name === "select-countries" && relate_field.indexOf(name) >= 0) {
    const countries = [...filterData.countries];
    // Exclude EXOGROUP
    // const searchData = Func.SearchObject(countries, "EXOGROUP", "country_code");
    // if (Object.keys(searchData).length > 0) {
    //   const index = Object.keys(searchData)[0];
    //   countries.splice(index, 1);
    // }
    return countries;
  } else if (name === "select-salesoffice" && relate_field.indexOf(name) >= 0) {
    return filterData.salesoffice;
  } else if (name === "select-agent_code" && relate_field.indexOf(name) >= 0) {
    const type = data["select-type"];
    const countries = data["select-countries"];
    if ((type === 5 || type === 9) && filterData.agents["xml"]?.[countries]) {
      return filterData.agents["xml"][countries];
    } else if (filterData.agents["booking"]?.[countries]) {
      return filterData.agents["booking"][countries];
    }
  } else if (name === "select-department" && relate_field.indexOf(name) >= 0) {
    const countries = data["select-countries"];
    if (filterData.departments?.[countries]) {
      return filterData.departments[countries];
    }
  }
  return [];
};

export default function RecipFormAdd({ handleEvents }) {
  const { filters, filterData, storeFilters } = useInfo();
  const defaultAddData = {
    key_form: 0,
    index: -1,
    "select-type": 0,
    "select-senttype": "",
    "select-countries": "None",
    "select-salesoffice": "",
    "select-agent_code": "",
    "select-department": "",
  };
  const [addData, setAddData] = useState({ ...defaultAddData });
  handleEvents.RecipForm = {
    OnSubmit: function (evt) {
      // console.log("addData=>", addData); //return;
      if (Object.keys(addData).length === 0) {
        return;
      }
      const mainParams = {
        addData: addData,
        userID: window.$user_profile.idu,
        staffID: filters?.idu ?? 0,
        staffEmail: filters?.email ?? "",
      };
      const mainFunc = async () =>
        await API.post("info/user/notification/add", {
          params: ({
            addData: addData,
            userID: window.$user_profile.idu,
            staffID: filters?.idu ?? 0,
            staffEmail: filters?.email ?? "",
          }),
        });
      mainFunc()
        .then((res) => {
          const decrypt = (res?.data);
          // console.log("user notification add=", decrypt);
          if (decrypt?.status === "success") {
            if (decrypt?.data) {
              storeFilters({
                ...filters,
                user_recips: decrypt.data,
                key_form: Func.GetKeyRandom(),
              });
            }
          }
        })
        .catch((err) => {
          //console.log(infos.tabActive, err)
          //storeFilterData({ err: 1, err_msg: `Failes : ${err}` });
        });
    },
    OnSelectChange: function (evt, { id, name, value }) {
      if (name === "select-type") {
        const recipData = filterData.data.email_recips.find(
          (item) => item.value === parseInt(value)
        );
        const index = recipData?.index ?? -1;
        setAddData({
          ...defaultAddData,
          index: index,
          "select-type": parseInt(value),
          key_form: Func.GetKeyRandom(),
        });
      } else {
        setAddData({
          ...addData,
          [name]: value,
          key_form: Func.GetKeyRandom(),
        });
      }
    },
  };
  useEffect(() => {}, []);

  let addClass = "col s4";
  const boxName = "content-employeeinfo";
  // console.log("filterData=>", filterData.data);
  const selectOptions = {
    "select-senttype": GetSelectOptions(
      "select-senttype",
      addData,
      filterData.data
    ),
    "select-countries": GetSelectOptions(
      "select-countries",
      addData,
      filterData.data
    ),
    "select-agent_code": GetSelectOptions(
      "select-agent_code",
      addData,
      filterData.data
    ),
    "select-salesoffice": GetSelectOptions(
      "select-salesoffice",
      addData,
      filterData.data
    ),
    "select-department": GetSelectOptions(
      "select-department",
      addData,
      filterData.data
    ),
  };
  //console.log("addData=>", addData);
  // console.log("select-countries=>", selectOptions["select-countries"]);
  return (
    <div
      key={"recip-box-form-add-" + addData.key_form}
      id="recip-box-form-add"
      style={{
        padding: "15px 15px 15px 25px",
        background: "#fff",
        marginTop: "30px",
        marginBottom: "30px",
        border: "1px dashed #26a69a",
      }}
    >
      <Row className={boxName} style={{ marginBottom: "10px" }}>
        <FormFunc.SingleSelect
          data={{
            id: "",
            name: "select-type",
            label: "Notification type*",
            options: filterData.data.email_recips,
            addClass: addClass,
            optionName: "name",
            optionValue: "value",
            //optionTitle: "---",
            defaultValue: addData["select-type"],
          }}
          events={handleEvents.RecipForm}
        />
        <FormFunc.SingleSelect
          data={{
            id: "",
            name: "select-senttype",
            label: "TO/CC/BCC*",
            options: selectOptions["select-senttype"],
            addClass: addClass,
            optionName: "name",
            optionValue: "value",
            optionTitle: "---",
            disabled:
              selectOptions["select-senttype"].length === 0 ? true : false,
            defaultValue: addData["select-senttype"],
          }}
          events={handleEvents.RecipForm}
        />
        <FormFunc.SingleSelect
          data={{
            id: "",
            name: "select-countries",
            label: "Country*",
            options: selectOptions["select-countries"],
            addClass: addClass,
            optionName: "country_name",
            optionValue: "country_name",
            optionTitle: "---",
            disabled:
              selectOptions["select-countries"].length === 0 ? true : false,
            defaultValue: addData["select-countries"],
          }}
          events={handleEvents.RecipForm}
        />
      </Row>
      <Row className={boxName} style={{ marginBottom: "10px" }}>
        <FormFunc.SingleSelect
          data={{
            id: "",
            name: "select-salesoffice",
            label: "Sales Office",
            options: selectOptions["select-salesoffice"],
            addClass: addClass,
            optionName: "name",
            optionValue: "name",
            optionTitle: "---",
            disabled:
              selectOptions["select-salesoffice"].length === 0 ? true : false,
            defaultValue: addData["select-salesoffice"],
          }}
          events={handleEvents.RecipForm}
        />
        <FormFunc.SingleSelect
          data={{
            id: "",
            name: "select-agent_code",
            label: "Agent Code",
            options: selectOptions["select-agent_code"],
            addClass: addClass,
            optionName: "name",
            optionValue: "value",
            optionTitle: "---",
            disabled:
              selectOptions["select-agent_code"].length === 0 ? true : false,
            defaultValue: addData["select-agent_code"],
          }}
          events={handleEvents.RecipForm}
        />
        <FormFunc.SingleSelect
          data={{
            id: "",
            name: "select-department",
            label: "Department",
            options: selectOptions["select-department"],
            addClass: addClass,
            optionName: "name",
            optionValue: "name",
            optionTitle: "---",
            disabled:
              selectOptions["select-department"].length === 0 ? true : false,
            defaultValue: addData["select-department"],
          }}
          events={handleEvents.RecipForm}
        />
      </Row>
      <Row className={boxName} style={{ paddingRight: "12px" }}>
        <Button
          className="light-blue accent-2"
          id="btn-update-new-recip"
          node="button"
          waves="light"
          small={true}
          style={{ float: "right", width: "100px", borderRadius: "0px" }}
          onClick={handleEvents.RecipForm.OnSubmit}
        >
          ADD NEW
        </Button>
      </Row>
    </div>
  );
}

